import { FC, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ButtonPromo, TextPromo } from 'components/ui'
import { Href } from 'components/ui/Href/Href'
import { Space } from 'components/ui/Space/Space'
import { Flex } from 'components/uiKit/Flex/Flex'
import { sendAdriverEvent } from 'utils/adriver/sendAdriverEvent'
import { isGeDomain } from 'utils/helpers/domains/getDomain'
import { sendEvent } from 'utils/helpers/sendEvent'
import { useResize } from 'utils/hooks/useResize'
import { URLS } from 'shared/constants/urls'
import { AdriverEventType, EventType } from 'types/types'

import { PromoPageKeys } from '../../types'
import { markerItems } from './data'

import Marker from 'assets/img/promo-page/mapMarker.svg?react'
import ArrowIcon from 'assets/img/shared/arrow2.svg?react'
import s from './Map.module.scss'

export const Map: FC = () => {
  const { isTablet, isSTablet } = useResize()
  const [activeMarker, setActiveMarker] = useState<string | null>('0')
  const mapRef = useRef<HTMLDivElement>(null)
  const [mapDimensions, setMapDimensions] = useState<{ width: number; height: number }>({ width: 0, height: 0 })
  const { t } = useTranslation()

  const fontSize = isTablet ? (isSTablet ? 's16' : 's20') : 's24'

  const mapLink = isGeDomain() ? URLS.pick_point_map_ge : URLS.pick_point_map

  const getKey = (key: string) => `${PromoPageKeys.map}.${key}`

  useEffect(() => {
    if (mapRef.current) {
      const { offsetWidth, offsetHeight } = mapRef.current
      setMapDimensions({ width: offsetWidth, height: offsetHeight })
    }
  }, [isSTablet])

  const handleItemClick = (id: string) => {
    setActiveMarker(id)
  }

  return (
    <div>
      <Space size={!isTablet ? 170 : !isSTablet ? 70 : 50} />
      <div className={s.mapSection}>
        <div className={s.map}>
          <Flex vertical className={s.textWrapper} gap={isTablet ? (isSTablet ? 24 : 32) : 56}>
            <TextPromo size={isTablet ? (isSTablet ? 's20' : 's32') : 's44'} fontFamily="ASLHaussVF" weight="w550">
              {t(getKey('Выберите лучшее место на карте'))}
              <ul className={s.list}>
                {markerItems.map((item) => (
                  <div
                    key={item.id}
                    className={`${s.listItem} ${activeMarker === item.id ? s.active : ''}`}
                    onClick={() => handleItemClick(item.id)}
                  >
                    <div className={s.circle} style={{ backgroundColor: item.color }} />
                    <div className={s.text}>
                      <div className={s.textWithIcon}>
                        <TextPromo
                          fontFamily="ASLHauss"
                          size={fontSize}
                          className={s.mainText}
                          style={{ color: activeMarker === item.id ? '#000' : '#77767E' }}
                          weight="w400"
                        >
                          {t(getKey(item.text))}
                        </TextPromo>
                        &nbsp;
                        <ArrowIcon className={`${s.arrowIcon} ${activeMarker === item.id ? s.arrowIconActive : ''}`} />
                      </div>

                      {activeMarker === item.id && (
                        <TextPromo
                          fontFamily="ASLHauss"
                          size={isSTablet ? 's14' : 's16'}
                          className={s.caption}
                          weight="w400"
                        >
                          {item.caption}
                        </TextPromo>
                      )}
                    </div>
                  </div>
                ))}
              </ul>
            </TextPromo>
            <ButtonPromo className={s.button}>
              <Href
                href={mapLink}
                className={s.buttonLink}
                target="_blank"
                rel="noreferrer"
                linkType="search"
                onClick={() => {
                  sendEvent(EventType.MainCartPUPT,{section: 'Открытие'})
                  sendAdriverEvent(AdriverEventType.openMap)
                }}
              >
                Открыть карту
              </Href>
            </ButtonPromo>
          </Flex>
          <div className={s.mapWrapper} ref={mapRef}>
            <Href
              href={mapLink}
              className={s.mapImage}
              target="_blank"
              rel="noreferrer"
              linkType="search"
              onClick={() => sendEvent(EventType.MainCartPUPT)}
            >
              {markerItems.map((item) => {
                const coordinates = isSTablet ? item.mobileCoordinates : item.coordinates
                return (
                  activeMarker === item.id && (
                    <Marker
                      key={item.id}
                      className={s.marker}
                      style={{
                        left: `${(coordinates.xPercent / 100) * mapDimensions.width}px`,
                        top: `${(coordinates.yPercent / 100) * mapDimensions.height}px`,
                      }}
                    />
                  )
                )
              })}
            </Href>
          </div>
        </div>
      </div>
    </div>
  )
}
